import React, { useEffect, useState } from "react";

const Tabs = ({
  children,
  tabs,
  onSelect,
  selectedTabClass,
  renderCondition,
  selectedTab,
  classN,
}) => {
  const [selected, setSelected] = useState(
    renderCondition ? selectedTab : tabs[0].value
  );

  const handleSelect = (value) => {
    onSelect(value);
    setSelected(value);
  };

  useEffect(() => {
    if (selectedTab) {
      setSelected(selectedTab);
    }
  }, [selectedTab]);

  return (
    <div className={!classN ? `tabs home_tabs` : `tabs home_tabs ${classN}`}>
      <ul>
        {tabs.map(({ value, label, forRenderCondition }) => {
          return !renderCondition ? (
            <>
              <li
                onClick={() => handleSelect(value)}
                className={
                  value === selected
                    ? `is-active ${selectedTabClass ? selectedTabClass : ""}`
                    : ""
                }
              >
                <button>{label}</button>
                {/* <a>{label}</a> */}
              </li>
            </>
          ) : forRenderCondition === "0" ? (
            ""
          ) : (
            <>
              <li
                onClick={() => handleSelect(value)}
                className={
                  value === selected
                    ? `is-active ${selectedTabClass ? selectedTabClass : ""}`
                    : ""
                }
              >
                <button>{label}</button>
                {/* <a>{label}</a> */}
              </li>
            </>
          );
        })}
      </ul>
    </div>
  );
};

export default Tabs;
